import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { updateTranscription, updateTranslation } from '../../actions';
import ItemSelector from '../ItemSelector';
import transcriptions from '../../constants/transcriptions.json';
import translations from '../../constants/translations.json';
import styled from 'styled-components';
import { Switch } from '@blueprintjs/core';

const Container = styled.div`
  margin-top: 10px;
`;

const TitleContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start
`;

const Title = styled.div`
  font-weight: 600;
  margin-right: 5px;
`;

class LanguageSettings extends React.Component {

  onTranscriptionSelection = item => this.props.updateTranscription(item);

  onTranslationSelection = item => this.props.updateTranslation(item);

  handleTranslationSwitch = e => {
    const translation = this.props.translation;
    translation.enabled = e.target.checked;
    this.props.updateTranslation(translation)
  };

  render() {

    const {transcription, translation} = this.props;

    return (
      <Container>
        <TitleContainer>
          <Title>Transcription</Title>
          <div className="pt-form-helper-text">
            (Speech-to-text)
          </div>
        </TitleContainer>
        <ItemSelector
          item={transcription}
          onItemSelect={this.onTranscriptionSelection}
          items={transcriptions}
        />
        <div className="horizontal-divider"/>
        <TitleContainer>
          <Title>Translation</Title>
        </TitleContainer>
        <Switch
          style={{marginTop: 10, marginBottom: 5}}
          checked={translation.enabled}
          labelElement={translation.enabled ? 'Enabled' : 'Disabled'}
          onChange={this.handleTranslationSwitch}
        />
        {translation.enabled ?
          <ItemSelector
            item={translation}
            onItemSelect={this.onTranslationSelection}
            items={translations}
          /> : null
        }
      </Container>
    );
  }
}

function mapStateToProps(state) {
  return {
    transcription: state.transcription,
    translation: state.translation
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    updateTranscription,
    updateTranslation
  }, dispatch)
}

LanguageSettings = connect(
  mapStateToProps,
  mapDispatchToProps
)(LanguageSettings);

export default LanguageSettings;



// WEBPACK FOOTER //
// ./src/containers/LanguageSettings/index.js